/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { CreateDailyActivityMonitoringLogHeaderInputDto } from './createDailyActivityMonitoringLogHeaderInputDto.schema';

export const CreateDailyActivityMonitoringLogHeader = zod.object({
  "payload": zod.lazy(() => CreateDailyActivityMonitoringLogHeaderInputDto).optional()
});

export type CreateDailyActivityMonitoringLogHeader = zod.input<typeof CreateDailyActivityMonitoringLogHeader>;
export type CreateDailyActivityMonitoringLogHeaderOutput = zod.output<typeof CreateDailyActivityMonitoringLogHeader>;
